import React from 'react';
import { ClipboardList } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import DashboardSubmenu from './DashboardSubmenu';
import ItenerariesSubmenu from './ItenerariesSubmenu';
import FocusProductsSubmenu from './FocusProductsSubmenu';
import MapSubmenu from './MapSubmenu';
import BlueprintSubmenu from './BlueprintSubmenu';
import SalesPerformanceSubmenu from './SalesPerformanceSubmenu';

function PlaceholderPanel({ title, description, heading }) {
  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h2>
        <p className="text-gray-600 dark:text-gray-200">{description}</p>
      </div>
      <Card className="glass border-0 shadow-lg">
        <CardContent className="py-12">
          <div className="text-center">
            <ClipboardList className="mx-auto mb-4 h-16 w-16 text-gray-400" />
            <h3 className="mb-2 text-lg font-medium text-gray-900 dark:text-white">{heading}</h3>
            <p className="text-gray-500 dark:text-gray-300">Content coming soon.</p>
          </div>
        </CardContent>
      </Card>
    </>
  );
}

export default function SalesDepartmentToolsContent(props) {
  const { activeMenuItem } = props;

  return (
    <div className="space-y-6">
      {activeMenuItem === 'project-details' && <DashboardSubmenu />}
      {activeMenuItem === 'project-details-iteneraries' && <ItenerariesSubmenu {...props} />}
      {activeMenuItem === 'project-details-focus-products' && <FocusProductsSubmenu {...props} />}
      {activeMenuItem === 'project-details-map' && <MapSubmenu {...props} />}
      {(activeMenuItem === 'project-details-blueprint' || activeMenuItem === 'blueprint-account-details') && <BlueprintSubmenu {...props} />}
      {(activeMenuItem === 'project-details-info' || activeMenuItem === 'sales-account-details') && <SalesPerformanceSubmenu {...props} />}
      {activeMenuItem === 'project-details-performance' && (
        <PlaceholderPanel title="Performance" description="Project performance metrics" heading="Performance Section" />
      )}
      {activeMenuItem === 'project-details-incentives' && (
        <PlaceholderPanel title="Incentives Computation" description="Incentives calculation and tracking" heading="Incentives Computation Section" />
      )}
    </div>
  );
}
